export type { IconProps } from '../../types/icon';
export { Icon } from './adapters/inbound/Icon';
